export default __webpack_public_path__ + "static/media/icon_popit.b09b982e.png";